import React from "react";
import { useTranslation } from "react-i18next";

import { LocalizedLink } from "../i18n/LocaleRouting";

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="text-white w-full bg-[#02050c]">
      <div className="m-auto grid grid-cols-1 md:grid-cols-2 mx-auto md:gap-10 md:max-w-[1600px] px-6 py-6">
        <div className="flex flex-col gap-6">
          <div className="text-white font-bold flex items-center">
            <img
              src="/icon/tcg-logo.png"
              alt={t("brand.logoAlt")}
              className="w-9 h-9"
              draggable={false}
              onDragStart={(e) => e.preventDefault()}
            />
            <span className="text-lg font-bold text-[#fff]">{t("brand.name")}</span>
          </div>
          <div className="text-xs md:text-sm text-white font-medium opacity-80 md:opacity-90 mb-5">
            {t("footer.blurb")}
          </div>
        </div>
        <div className="w-full flex md:justify-center brightness-[90%] contrast-[102%] saturate-[130%]">
          <img
            src="/icon/hotshoplogo.png"
            alt={t("brand.name")}
            className="md:w-[66%] w-[76%] object-contain"
            draggable={false}
            onDragStart={(e) => e.preventDefault()}
          />
        </div>
      </div>

      <div className="bg-[#000] mt-0 pb-4 px-6">
        <div className="font-medium md:max-w-[1600px] md:mt-0 bg-[#000] md:m-auto px-0">
          <div className="py-4 grid grid-cols-1 md:grid-cols-2 mx-auto bg-slate-0">
            <div className="text-xs text-ellipsis line-clamp-1 leading-4 font-medium">
              {t("footer.rights")} |
              <LocalizedLink
                to="/privacy"
                className="text-[#F05A2A] cursor-pointer hover:underline ml-1 font-bold"
              >
                {t("footer.privacy")}
              </LocalizedLink>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
